module.exports = __webpack_public_path__ + "static/media/customer-info-finish.8a78f756.svg";